<p-dialog
  header="Gerenciar Apontamentos - #{{ ticket.ticket_number_teorema }}"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{
    width: '90vw',
    'max-width': '850px',
    height: '90vh',
    'max-height': '90vh',
  }"
  [baseZIndex]="10000"
  [breakpoints]="{ '768px': '95vw', '480px': '100vw' }"
  (onHide)="onHide()"
  styleClass="time-entry-modal"
  [contentStyle]="{
    padding: '0',
    height: 'calc(90vh - 130px)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  }">
  <!-- Abas do Modal -->
  <div class="modal-tabs">
    <button class="tab-button" [class.active]="activeTab() === 'new'" (click)="showNewForm()">
      <i class="pi pi-clock"></i>
      Apontamento
    </button>
    <button class="tab-button" [class.active]="activeTab() === 'history'" (click)="showHistory()">
      <i class="pi pi-history"></i>
      Histórico ({{ ticketTimeEntries.length }})
    </button>
  </div>

  <!-- Conteúdo Dinâmico com Rolagem -->
  <div class="modal-content-wrapper">
    @if (activeTab() === 'new') {
      <div class="time-entry-form">
        <div class="form-grid grid p-fluid">
          <div class="col-6">
            <div class="field-group">
              <span class="field-label">
                Tipo
                <span class="required">*</span>
              </span>
              <p-select
                [options]="timeTypes"
                [ngModel]="timeEntryType()"
                (ngModelChange)="timeEntryType.set($event)"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione o tipo"
                class="w-full"
                appendTo="body" />
            </div>
          </div>
          <div class="col-6">
            <div class="field-group">
              <span class="field-label">
                Atendimento
                <span class="required">*</span>
              </span>
              <p-select
                [options]="attendanceTypes"
                [ngModel]="timeEntryAttendanceType()"
                (ngModelChange)="timeEntryAttendanceType.set($event)"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione o atendimento"
                class="w-full"
                appendTo="body" />
            </div>
          </div>
          <div class="col-6">
            <div class="field-group">
              <span class="field-label">
                Status
                <span class="required">*</span>
              </span>
              <app-favorite-select
                [options]="statusesList()"
                [(ngModel)]="timeEntryStatusId"
                optionLabel="description"
                optionValue="id"
                placeholder="Selecione o status"
                [filter]="true"
                (onFilter)="onStatusFilter($event)"
                [loading]="statusesLoading()"
                emptyFilterMessage="Nenhum status encontrado"
                class="w-full"
                appendTo="body"
                [favorites]="true"
                [favoritesKey]="FavoriteKey.TicketStatuses" />
            </div>
          </div>
          <div class="col-6">
            <div class="field-group">
              <span class="field-label"> Tarefa </span>
              <p-select
                [options]="taskOptions()"
                [(ngModel)]="timeEntryTaskId"
                (ngModelChange)="onTaskSelectionChange($event)"
                [disabled]="activeTimeEntry !== null"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione a tarefa (opcional)"
                class="w-full"
                appendTo="body" />
            </div>
          </div>
          @if (canFinishTask()) {
            <div class="col-12 py-2">
              <p-toggleswitch [(ngModel)]="finishTask" inputId="finishTask" />
              <label for="finishTask" class="ml-2">Concluir tarefa</label>
            </div>
          }
          <div class="col-12">
            <div class="field-group">
              <span class="field-label">Sistema</span>
              <app-entity-picker
                title="Selecionar sistema"
                placeholder="Nenhum sistema selecionado"
                labelField="description"
                [searchFn]="searchSystemsFn"
                [value]="timeEntrySystem()"
                (valueChange)="timeEntrySystem.set($event)" />
            </div>
          </div>
          <div class="col-6">
            <div class="field-group">
              <span class="field-label">
                Início
                <span class="required">*</span>
              </span>
              <p-datepicker
                [(ngModel)]="timeEntryStartDate"
                dateFormat="dd/mm/yy"
                [showTime]="true"
                [showSeconds]="false"
                placeholder="Data e hora"
                class="w-full"
                appendTo="body" />
            </div>
          </div>
          <div class="col-6">
            <div class="field-group">
              <span class="field-label"> Fim </span>
              <p-datepicker
                [(ngModel)]="timeEntryEndDate"
                dateFormat="dd/mm/yy"
                [showTime]="true"
                [showSeconds]="false"
                placeholder="Data e hora"
                class="w-full"
                appendTo="body" />
            </div>
          </div>
          <!-- Vira um comentário do chamado — destino em TicketService.startTimeEntry. -->
          <div class="col-12">
            <div class="field-group">
              <span class="field-label">
                Comentário
                <i
                  class="pi pi-info-circle movement-info-icon"
                  pTooltip="Este texto vira um comentário do chamado (público define se o cliente pode visualizar) esse texto também será concatenado à descrição do apontamento."
                  tooltipPosition="top"></i>
              </span>
              <textarea
                pTextarea
                [autoResize]="true"
                [rows]="3"
                [placeholder]="
                  activeTimeEntry
                    ? 'Comentário final (opcional)...'
                    : 'Comentário inicial (opcional)...'
                "
                [ngModel]="movementDescription()"
                (ngModelChange)="movementDescription.set($event)"
                class="w-full"></textarea>
            </div>
          </div>
          <div class="col-12 py-2">
            <p-checkbox
              [binary]="true"
              inputId="commentPub"
              [ngModel]="commentPub()"
              (ngModelChange)="onCommentPubChange($event)" />
            <label for="commentPub" class="ml-2">Público</label>
          </div>
        </div>
      </div>
    }

    @if (activeTab() === 'history') {
      <app-time-entry-history
        [entries]="ticketTimeEntries"
        [activeEntry]="activeTimeEntry"
        (stopRequested)="stopTimeEntry()" />
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="form-actions">
      <p-button label="Cancelar" icon="pi pi-times" severity="secondary" (onClick)="onHide()" />
      @if (activeTab() === 'new') {
        @if (activeTimeEntry) {
          <p-button
            label="Encerrar Apontamento"
            icon="pi pi-stop"
            severity="danger"
            [loading]="sending()"
            (onClick)="stopTimeEntry()" />
        } @else {
          <p-button
            label="Iniciar Apontamento"
            icon="pi pi-play"
            severity="success"
            [loading]="sending()"
            (onClick)="onStartTimeEntry()" />
        }
      }
    </div>
  </ng-template>
</p-dialog>
